<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Company</span> 
          <span v-else>Create a New Company</span>
        </h1>
        <span>
          <router-link :to="{name: 'companies'}" class="btn btn_black">Back to List</router-link>
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div :class="['form_row', {'has_error': errorFor('company_name')}]">
                <label class="required">Company Name</label>
                <div class="form_inline">
                  <input type="text" class="form_global" v-model="company.company_name">
                  <v-errors :errors="errorFor('company_name')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('description')}]">
                <label>Description</label>
                <div class="form_inline">
                    <text-editor v-model:text="company['description']" :id="'description'"></text-editor>
                    <v-errors :errors="errorFor('description')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('notes')}]">
                <label>Notes</label>
                <div class="form_inline">
                    <text-editor v-model:text="company['notes']" :id="'notes'"></text-editor>
                    <v-errors :errors="errorFor('notes')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pl_20">
              <div :class="['form_row', {'has_error': errorFor('status')}]">
                  <label class="required">Status</label>
                  <div class="form_radio">
                      <input type="radio" id="statusActive" v-model="company.status" value="1">
                      <label for="statusActive">Active</label>
                  </div>
                  <div class="form_radio">
                      <input type="radio" id="statusInactive" v-model="company.status" value="0">
                      <label for="statusInactive">Inactive</label>
                  </div>
                  <v-errors :errors="errorFor('status')"></v-errors>
              </div>
              <div :class="['form_row', {'has_error': errorFor('domain')}]">
                <label>Company Domain</label>
                <div class="form_inline">
                  <input type="text" class="form_global" v-model="company.domain">
                  <v-errors :errors="errorFor('domain')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('photo')}]">
                <label>Profile Image</label>
                <div class="form_input center_horizontally">
                  <input ref="photo" type="file" class="form_global" accept="image/png, image/gif, image/jpeg" @input="onFileChange($event)">
                </div>
                <div class="form_row mt_10" v-if="tempFile">
                  <label></label>
                  <div class="inner_img p_relative display_inline">
                    <div class="cross_ic" @click.prevent="deleteFile">
                      <i class="fas fa-times"></i>
                    </div>
                    <img :src="tempFile" alt="" height="100" width="100">
                  </div>
                </div>
                <div v-else class="form_row mt_10">
                  <label></label>
                  <img v-if="company.photo" :src="company.photo" alt="" class="" width="100" height="100">
                </div>
              </div>
              <div class="form_row">
                <label></label>
                <div class="form_inline ">
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="update" v-if="$route.params.id">Update</button>
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="submit" v-else>Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
    import TextEditor from "@/components/shared/TextEditor";
    export default {
        name: 'company-form',
        components: {LoaderMaskComponent, TextEditor},
        data(){
            return {
              lyLoading: false,
              company: {
                company_name: '',
                photo: '',
                description: '',
                notes: '',
                domain: '',
                status: 1,
              },
              tempFile: null,
            }
        },
        created() {
            if(this.$route.params.id){
              this.loadData(this.$route.params.id)
            }
        },
        methods: {
          onFileChange(event){
              let files = event.target.files || event.dataTransfer.files;
              if (!files.length)
                  return;

              let file = event.target.files[0]
              this.company.photo = file

              this.tempFile = URL.createObjectURL(file);
          },
          deleteFile(){
              this.tempFile = null
              this.company.photo = null
              this.$refs.photo.value = null;
          },
          loadData(companyId){
              this.lyLoading = true;
              this.axios.get('/companies/'+companyId)
              .then((response) => {
                let companyData = response.data.data;
                this.company.company_name = companyData.company_name
                this.company.photo = companyData.photo
                this.company.description = companyData.description
                this.company.notes = companyData.notes
                this.company.domain = companyData.domain
                this.company.status = companyData.status ? 1 : '0'
              })
              .catch(() => {
                  this.showFailMsg("No company exists!");
              })
              .finally(() => {
                  this.lyLoading = false;
              })
          },
          submit() {
              this.allErrors = null;
              this.lyLoading = true;

              let formData = new FormData()

              Object.keys(this.company).forEach(key => {
                  formData.append(key, this.company[key] ? this.company[key] : '');
              })

              this.axios.post('/companies', formData)
              .then(() => {
                  this.resetForm();
                  this.showSuccessMsg("Company Created Successfully!");
                  this.$router.push({ name: 'companies'})
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
                  this.showFailMsg(err.response.data.message);
              })
              .finally(() => {
                  this.lyLoading = false;
              })

          },
          
          update(){
              this.allErrors = null;
              this.lyLoading = true;

              let formData = new FormData()

              formData.append('_method','PATCH')

              Object.keys(this.company).forEach(key => {
                formData.append(key, this.company[key] ? this.company[key] : '');
              })

              this.axios.post('/companies/'+this.$route.params.id, formData)
              .then(() => {
                  this.showSuccessMsg("Company Update Successfully!");
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
              })
              .finally(() => {
                  this.lyLoading = false;
              })
          },
          resetForm(){
              this.company = {
                company_name: '',
                photo: '',
                description: '',
                notes: '',
                domain: '',
                status: 1,
              }
          },
        }
    }
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back{
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic{
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
